import React, { useState } from 'react';
import { Paper, InputBase, IconButton, alpha } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

interface SearchBarProps {
  onSearch: (query: string) => void;
}

const SearchBar: React.FC<SearchBarProps> = ({ onSearch }) => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(searchQuery);
  };

  return (
    <Paper
      component="form"
      onSubmit={handleSubmit}
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        background: alpha('#1A1F2E', 0.8),
        border: '1px solid rgba(0, 217, 255, 0.2)',
        borderRadius: '8px',
        backdropFilter: 'blur(10px)',
        transition: 'all 0.3s ease',
        '&:hover': {
          borderColor: 'rgba(0, 217, 255, 0.4)',
          boxShadow: '0 4px 16px rgba(0, 217, 255, 0.05)',
        },
        '&:focus-within': {
          borderColor: 'rgba(0, 217, 255, 0.6)',
          boxShadow: '0 4px 16px rgba(0, 217, 255, 0.1)',
        },
      }}
    >
      <InputBase
        sx={{
          ml: 2,
          flex: 1,
          color: '#FFFFFF',
          fontSize: '0.95rem',
          '& ::placeholder': {
            color: 'rgba(255, 255, 255, 0.4)',
            opacity: 1,
          },
          '& input': {
            padding: '12px 0',
          },
        }}
        placeholder="Search by ticker or company name..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
      <IconButton
        type="submit"
        sx={{
          p: '12px',
          color: 'rgba(0, 217, 255, 0.7)',
          transition: 'all 0.2s ease',
          '&:hover': {
            color: '#00D9FF',
            backgroundColor: 'rgba(0, 217, 255, 0.1)',
          },
        }}
        aria-label="search"
      >
        <SearchIcon />
      </IconButton>
    </Paper>
  );
};

export default SearchBar;
